var h = Object.defineProperty;
var n = Object.getOwnPropertySymbols;
var i = Object.prototype.hasOwnProperty, d = Object.prototype.propertyIsEnumerable;
var c = (e, l, t) => l in e ? h(e, l, { enumerable: !0, configurable: !0, writable: !0, value: t }) : e[l] = t, m = (e, l) => {
  for (var t in l || (l = {}))
    i.call(l, t) && c(e, t, l[t]);
  if (n)
    for (var t of n(l))
      d.call(l, t) && c(e, t, l[t]);
  return e;
};
var o = (e, l) => {
  var t = {};
  for (var C in e)
    i.call(e, C) && l.indexOf(C) < 0 && (t[C] = e[C]);
  if (e != null && n)
    for (var C of n(e))
      l.indexOf(C) < 0 && d.call(e, C) && (t[C] = e[C]);
  return t;
};
import * as a from "react";
const p = (C) => {
  var r = C, {
    title: e,
    titleId: l
  } = r, t = o(r, [
    "title",
    "titleId"
  ]);
  return /* @__PURE__ */ a.createElement("svg", m({ width: 32, height: 32, viewBox: "0 0 20 20", fill: "currentColor", xmlns: "http://www.w3.org/2000/svg", "aria-labelledby": l }, t), e ? /* @__PURE__ */ a.createElement("title", { id: l }, e) : null, /* @__PURE__ */ a.createElement("g", { clipPath: "url(#clip0_3039_10624)" }, /* @__PURE__ */ a.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M4.16667 4.91699C3.92355 4.91699 3.69039 5.01357 3.51849 5.18548C3.34658 5.35739 3.25 5.59054 3.25 5.83366V14.167C3.25 14.4101 3.34658 14.6433 3.51849 14.8152C3.69039 14.9871 3.92355 15.0837 4.16667 15.0837H15.8333C16.0764 15.0837 16.3096 14.9871 16.4815 14.8152C16.6534 14.6433 16.75 14.4101 16.75 14.167V5.83366C16.75 5.59054 16.6534 5.35739 16.4815 5.18548C16.3096 5.01357 16.0764 4.91699 15.8333 4.91699H4.16667ZM2.45783 4.12482C2.91104 3.6716 3.52573 3.41699 4.16667 3.41699H15.8333C16.4743 3.41699 17.089 3.6716 17.5422 4.12482C17.9954 4.57803 18.25 5.19272 18.25 5.83366V14.167C18.25 14.8079 17.9954 15.4226 17.5422 15.8758C17.089 16.329 16.4743 16.5837 15.8333 16.5837H4.16667C3.52573 16.5837 2.91104 16.329 2.45783 15.8758C2.00461 15.4226 1.75 14.8079 1.75 14.167V5.83366C1.75 5.19272 2.00461 4.57803 2.45783 4.12482Z" }), /* @__PURE__ */ a.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M1.87598 5.41706C2.10575 5.07242 2.5714 4.97929 2.91604 5.20905L10 9.9317L17.084 5.20905C17.4286 4.97929 17.8943 5.07242 18.1241 5.41706C18.3538 5.76171 18.2607 6.22736 17.916 6.45713L10.416 11.4571C10.1641 11.6251 9.83592 11.6251 9.58399 11.4571L2.08399 6.45713C1.73935 6.22736 1.64622 5.76171 1.87598 5.41706Z" })), /* @__PURE__ */ a.createElement("defs", null, /* @__PURE__ */ a.createElement("clipPath", null, /* @__PURE__ */ a.createElement("rect", { width: 20, height: 20 }))));
};
export {
  p as default
};
